import { render } from "./DataList.vue?vue&type=template&id=7a19a579&scoped=true&ts=true"
import script from "./DataList.vue?vue&type=script&lang=ts"
export * from "./DataList.vue?vue&type=script&lang=ts"

import "./DataList.vue?vue&type=style&index=0&id=7a19a579&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a19a579"]])

export default __exports__